<div class="container-general-local-menu hidden-phone position-relative h-100 no-print">
    <!-- INTESTAZIONE no link esterno e alt-view a false -->
    <a *ngIf="!levelMenu[(levelMenu.length-2)].external && !levelMenu[(levelMenu.length-2)].alt_view" class="container-general-local-menu__title d-flex align-items-center"
        [routerLink]="navigationService.splitUrlRouterLink(levelMenu[(levelMenu.length-2)].link).path" 
        [queryParams]="navigationService.splitUrlRouterLink(levelMenu[(levelMenu.length-2)].link).queryParams"
    >
        <div *ngIf="!levelMenu[(levelMenu.length-2)].alt_view" class="d-flex col-1">
            <img loading="lazy" src="../../../../../assets/images/arrow_left_menu-local.svg" alt="back_icon | LUMSA">
        </div>
        <div class="col-11">
            <div class="ms-3 text-uppercase ls-label-medium-semibold truncate pe-3" [ngClass]="!levelMenu[(levelMenu.length-2)].alt_view ? 'text-brand-40' : 'text-neutral-50'">
                {{levelMenu[(levelMenu.length-2)].label}}
            </div>
        </div>
    </a>
    <!-- END INTESTAZIONE no link esterno e alt-view a false -->
    <!-- INTESTAZIONE link esterno e alt-view a false -->
    <a *ngIf="levelMenu[(levelMenu.length-2)].external && !levelMenu[(levelMenu.length-2)].alt_view" class="container-general-local-menu__title d-flex align-items-center"
        [href]="(levelMenu[(levelMenu.length-2)].link).path"
    >
        <div *ngIf="!levelMenu[(levelMenu.length-2)].alt_view" class="d-flex col-1">
            <img loading="lazy" src="../../../../../assets/images/arrow_left_menu-local.svg" alt="back_icon | LUMSA">
        </div>
        <div class="col-11">
            <div class="ms-3 text-uppercase ls-label-medium-semibold truncate pe-3" [ngClass]="!levelMenu[(levelMenu.length-2)].alt_view ? 'text-brand-40' : 'text-neutral-50'">
                {{levelMenu[(levelMenu.length-2)].label}}
            </div>
        </div>
    </a>
    <!-- END INTESTAZIONE link esterno e alt-view a false -->
    <!-- INTESTAZIONE alt-view a true -->
    <div *ngIf="levelMenu[(levelMenu.length-2)].alt_view" class="container-general-local-menu__title d-flex align-items-center">
        <div *ngIf="!levelMenu[(levelMenu.length-2)].alt_view" class="d-flex col-1">
            <img loading="lazy" src="../../../../../assets/images/arrow_left_menu-local.svg" alt="back_icon | LUMSA">
        </div>
        <div class="col-11">
            <div class="text-uppercase ls-label-medium-semibold truncate pe-3 text-neutral-50">
                {{levelMenu[(levelMenu.length-2)].label}}
            </div>
        </div>
    </div>
    <!-- END INTESTAZIONE alt-view a true -->
    <div class="d-flex">
        <div class="truncate container-item-local-menu">
            <div class="container-item-local-menu__items truncate bg-support-99 mb-2 ls-label-large-semibold">
                {{levelMenu[(levelMenu.length-1)].label}}
            </div>
        </div>
    </div>
    <div *ngIf="(levelMenu[(levelMenu.length-2)].subtree && levelMenu[(levelMenu.length-2)].subtree.length > 1) || levelMenu[(levelMenu.length-1)].subtree"
        class="d-flex align-items-end container-icon-expand">
        <img loading="lazy" class="cursor-pointer" src="../../../../../assets/images/side-menu-expand.svg" alt="menu expand"
            (click)="openMenu()">
    </div>
</div>